export const ReportOptions: { [key: string]: string } = {
  inappropriate: 'Inappropriate content',
  inappropriate_profile_photo: 'Inappropriate profile photo',
  incorrect_profile_photo: 'Incorrect profile photo',
  harassment: 'Harassment/bullying',
  threaten: 'Threatening harm to me or others',
  impersonator: 'Pretending to be someone else',
  self_harm: 'At risk of harming him or herself',
  hateful: 'Using hate speech or encouraging extreme acts',
};
export const ReportOrgUserOptions: { [key: string]: string } = Object.assign(
  { not_at_this_school: 'No longer at this school' },
  ReportOptions
);
export const ReportOtherOption = 'other';
